export default "__VITE_ASSET__CC9mSUES__"